import { useEffect } from "react"
import { scrollToTop } from "../utils/scrollHelpers";

export const useScrollTop = () => {
    useEffect(() => {
        scrollToTop();
    }, [])
}